import './Loading.css'
export default function Loading() {
    return (
            <div id='container-load'>
                <div id="loading"></div>
            </div>
    )
}